export const DEFAULT_TRAUMA_NAVIGATION_TITLE = 'Trauma';

export const DEFAULT_TRAUMA_PRODUCT_TITLE = 'Trauma support';

export const DEFAULT_TRAUMA_PRODUCT_DESCRIPTION_PARAGRAPHS = [
  'We know that healthcare staff may face psychological trauma in their work, especially where they are part of the response to major incidents and trusts have their own processes in place to support staff when they encounter trauma in their work.',
  'The Trust has recognised this and has built this capacity to support staff to deal with trauma over a longer period and to avoid poorer mental health outcomes for staff.',
] as const;

export const DEFAULT_TRAUMA_INTRO_QUESTION_TITLE =
  'Have you recently experienced a difficult incident?';

export const DEFAULT_TRAUMA_INTRO_QUESTION_DESCRIPTION =
  "We understand that difficult experiences can happen. This section is here to help you prioritise your wellbeing if you've recently encountered a situation that has impacted you.";

export const DEFAULT_TRAUMA_REFERENCE_NUMBER_LABEL = 'Reference number';
